import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Accordion.module.css';
import Cards from '../../CardsUI/Cards/Cards';
const AccordionItem = ({ 
  item, 
  isActive, 
  index,
  totalItems, 
  onToggle,
  contentRef 
}) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  // Добавляем слушатель изменения размера окна
  useEffect(() => {
    // Функция для обновления состояния
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    // Добавляем слушатель
    window.addEventListener('resize', handleResize);
    
    // Удаляем слушатель при размонтировании компонента
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { title, content } = item;
  const { description, images, link_to } = content || {};
  
  // Контейнер для содержимого (используется для анимации)
  const contentWrapperRef = useRef(null);
  
  // Управление анимацией высоты при открытии/закрытии
  // useEffect(() => {
  //   const wrapper = contentWrapperRef.current;
    
  //   if (wrapper) {
  //     if (isActive) {
  //       const height = contentRef.current.scrollHeight;
  //       wrapper.style.height = `${height}px`;
  //     } else {
  //       wrapper.style.height = '0px';
  //     }
  //   }
  // }, [isActive, contentRef]);
  
  return (
    <div 
      className={`${styles.section} ${isActive ? styles.expanded : ''}`}
      style={{
        marginTop: isDesktop && index !== 0 ? '-24px' : '0', // Нахлест секций только для десктопа
        zIndex: index + 1,
        position: 'relative',
        background: '#fff'
      }}
    >
    
      {/* Заголовок секции */}
      <div 
        className={styles.sectionHeader} 
        onClick={() => onToggle(index)}
      >
        <h3>{title}</h3>
      </div>
      
      {/* Контейнер для анимации */}
      <div 
        ref={contentWrapperRef}
        className={styles.contentWrapper}
      >
        {/* Основное содержимое */}
        <div 
          ref={contentRef}
          className={styles.sectionContent}
        >
          {/* Описание */}
          {description && <p className={styles.description}>{description}</p>}
          
          {/* Галерея изображений */}
          
          <Cards cards={images} maxCardHeight={'170px'} maxCardWidth={'340px'} maxCardsWidth={'100%'} maxCardTitleHeight={'85px'} carousel={true}/>
          {/* {images && images.length > 0 && (
            <div className={styles.imagesGrid}>
              {images.map((image, imgIndex) => (
                <div key={imgIndex} className={styles.imageContainer}>
                  <img 
                    src={image.src} 
                    alt={image.alt} 
                    className={styles.sectionImage}
                  />
                  <p>{image.alt}</p>
                </div>
              ))}
            </div>
          )} */}
          
          {/* Кнопка "Перейти в раздел" с использованием компонента Link */}
          {link_to && (
            <div className={styles.linkContainer}>
              <Link to={`/${link_to}`} className={styles.sectionLink}>
                Перейти в раздел
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
